module.exports = __webpack_public_path__ + "media/Images/why-choose-us-advisor-b697f17d2736deaa992ceddcfb928415.jpg";